var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_119703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7988 12.1113C21.7988 17.4616 17.4616 21.7988 12.1113 21.7988C6.76105 21.7988 2.42383 17.4616 2.42383 12.1113C2.42383 6.76106 6.76105 2.42383 12.1113 2.42383C17.4616 2.42383 21.7988 6.76106 21.7988 12.1113ZM10.9908 17.2408L18.1783 10.0533C18.4223 9.80922 18.4223 9.41348 18.1783 9.16941L17.2944 8.28555C17.0504 8.04145 16.6546 8.04145 16.4105 8.28555L10.5488 14.1472L7.81215 11.4105C7.56809 11.1664 7.17234 11.1664 6.92824 11.4105L6.04437 12.2944C5.80031 12.5384 5.80031 12.9342 6.04437 13.1782L10.1069 17.2407C10.351 17.4848 10.7467 17.4848 10.9908 17.2408Z",
    fill: "#10B981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_119703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.11133 2.11133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCheck);
export default __webpack_public_path__ + "static/media/toastCheck.09128b7543700b059fb09fd053e8fb8a.svg";
export { ForwardRef as ReactComponent };